import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { UserNotificationRepository } from "@app/core/notifications/domain/user-notification.repository";
import { GetNotificationsListWebService } from "@app/core/notifications/data/network/get-notifications-list.ws";
import { UserNotificationListResponse } from "@app/core/notifications/domain/user-notification-list-response";
import { GetUnreadNotificationsQuantityWebService } from "@app/core/notifications/data/network/get-unread-notifications-quantity.ws";
import { DeleteNotificationWebService } from "@app/core/notifications/data/network/delete-notification.ws";
import { ReadNotificationWebService } from "@app/core/notifications/data/network/read-notification.ws";
import { GetNotificationBannerWebService } from "@app/core/notifications/data/network/get-notification-banner.ws";
import { MarketingMessage } from "@app/core/marketing/domain/marketing-message";

@Injectable()
export class UserNotificationDataRepository
  implements UserNotificationRepository
{
  constructor(
    private getNotificationsListWS: GetNotificationsListWebService,
    private getUnreadNotificationsQuantityWS: GetUnreadNotificationsQuantityWebService,
    private readNotificationWS: ReadNotificationWebService,
    private deleteNotificationWS: DeleteNotificationWebService,
    private getNotificationBannerWS: GetNotificationBannerWebService
  ) {}

  getNotificationsResponse(
    token: string
  ): Observable<UserNotificationListResponse> {
    return this.getNotificationsListWS.execute(token);
  }

  getUnreadNotificationsQuantity(token: string): Observable<number> {
    return this.getUnreadNotificationsQuantityWS.execute(token);
  }

  readNotification(id: number, token: string): Observable<void> {
    return this.readNotificationWS.execute(id, token);
  }

  deleteNotification(id: number, token: string): Observable<void> {
    return this.deleteNotificationWS.execute(id, token);
  }

  getNotificationBanner(
    notificationId: number,
    token: string
  ): Observable<MarketingMessage> {
    return this.getNotificationBannerWS.execute(notificationId, token);
  }
}
